import React, { useState, useRef, useEffect } from "react";
import { IoMdCloudUpload } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import "../../index.css";
import { useQuery, gql, useMutation } from "@apollo/client";
import axios from "axios";
import Loader from "../../Loader";
import { stringify } from "ajv";
import BackButton from "../CommonComponents/BackButton";
import LabeledSwitch from "../CommonComponents/CustomSwitch";

const GET_INVENTORY_LIST = gql`
  query {
    getInventoryCategory {
      status
      message
      categories {
        id
        name
      }
    }
  }
`;

const GET_CATEGORY = gql`
  query {
    getCategory {
      status
      message
      categoryList {
        id
        name
      }
    }
  }
`;
//updateService(data: UpdateServiceInput!): EntryResponse!
const UPDATE_SERVICE = gql`
  mutation updateService($data: UpdateAdminServiceInput!) {
    updateService(data: $data) {
      status
      message
    }
  }
`;

const GET_PRODUCT = gql`
  query ($data: ID!) {
    getProductByCategoryId(data: $data) {
      status
      message
      products {
        id
        name
      }
    }
  }
`;
const GET_SERVICES = gql`
  query {
    getAdminService {
      services {
        id
        name
      }
    }
  }
`;

const ServiceEditForm = ({ editFormData, setEditForm }) => {
  console.log("editFormData");
  console.log(editFormData);
  const {
    data: serviceData,
    loading: serviceloading,
    error: serviceerror,
  } = useQuery(GET_SERVICES);
  const {
    data: otherData,
    loading: otherLoading,
    error: otherError,
  } = useQuery(GET_CATEGORY);
  const {
    data: productData,
    loading: productLoading,
    error: productError,
    refetch,
  } = useQuery(GET_PRODUCT);

  const { data, loading, error } = useQuery(GET_INVENTORY_LIST);

  const [updateService, { addLoading, addError }] = useMutation(UPDATE_SERVICE);
  const [name, setName] = useState(editFormData.name);
  const [price, setPrice] = useState(editFormData.price);
  const [time, setTime] = useState(editFormData.time);
  const [category, setCategory] = useState(editFormData.serviceCategory.id);
  const [subCategory, setSubCategory] = useState(editFormData.product.id);
  const [imageURL, setImageURL] = useState(editFormData.imageURL);
  const [image, setImage] = useState(null);
  const [productsUsed, setProductsUsed] = useState(
    editFormData.productsUsed?.length > 0
      ? editFormData.productsUsed.map((p) => ({ name: p.name || "", imageUrl: p.imageUrl || "" }))
      : []
  );
  const [gender, setGender] = useState(editFormData.gender);
  const [isFeatured, setIsFeatured] = useState(editFormData.isFeatured);
  const [inventoryList, setInventoryList] = useState([
    { inventoryId: "", price: "", alternateGroupId: "" },
  ]);
  const [dataList, setDataList] = useState([]);
  const [dataCategoryList, setDataCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [description, SetDesciption] = useState(editFormData.description);
  //further added
  const [details, setdetails] = useState(editFormData.details);
  const [serviceList, setServiceList] = useState([]);
  const [cutPrice, setCutPrice] = useState(editFormData.cutPrice);
  const [quick_price, setquick_price] = useState(editFormData.quickPrice);
  const [freeService, setFreeService] = useState(editFormData.freeService);
  const [shortDescription, setshortDescription] = useState(
    editFormData.shortDescription
  );
  const [specialPrice, setspecialPrice] = useState(editFormData.specialPrice);
  const [campaignPrice, setCampaignPrice] = useState(
    editFormData.campaignPrice ?? ""
  );
  const [campaignStartAt, setCampaignStartAt] = useState(
    editFormData.campaignStartAt
      ? editFormData.campaignStartAt.substring(0, 10)
      : ""
  );
  const [campaignEndAt, setCampaignEndAt] = useState(
    editFormData.campaignEndAt
      ? editFormData.campaignEndAt.substring(0, 10)
      : ""
  );
  const [campaignLabel, setCampaignLabel] = useState(
    editFormData.campaignLabel ?? ""
  );
  const [recommendServiceList, setrecommendServiceList] = useState(
    editFormData.recommendations ?? [""]
  );
  const [displayOrder, setDisplayOrder] = useState(editFormData.displayOrder);
  const [isPackage, setIsPackage] = useState(editFormData.isPackage || false);
  const [allowTimeBypass, setAllowTimeBypass] = useState(editFormData.allowTimeBypass || false);
  const [requiresTimerVerification, setRequiresTimerVerification] = useState(editFormData.requiresTimerVerification || false);
  const [selectionCount, setSelectionCount] = useState(editFormData.selectionCount || "");
  const [inventoryGenerationMode, setInventoryGenerationMode] = useState(editFormData.inventoryGenerationMode || "ON_BOOKING");
  const [packageChildServiceIds, setPackageChildServiceIds] = useState(
    editFormData.packageChildServices && editFormData.packageChildServices.length > 0 
      ? editFormData.packageChildServices.map(s => s.id) 
      : [""]
  );

  const [metaData, setMetaData] = useState(() => {
    try {
      return typeof editFormData.metaData === "string"
        ? JSON.parse(editFormData.metaData)
        : editFormData.metaData || {};
    } catch {
      return {};
    }
  });

  const [metaDataInput, setMetaDataInput] = useState(
    JSON.stringify(metaData, null, 2)
  );

  useEffect(() => { });

  const fileInputRef = useRef(null);

  useEffect(() => {
    try {
      console.log("product data is {}", editFormData.serviceCategory.id);
      refetch({ data: editFormData.serviceCategory.id })
        .then((res) => {
          console.log("onCategoryChange hitted");
          console.log(res);
          setProductList(res.data.getProductByCategoryId.products);
        })
        .catch((err) => {
          console.log(err);
        });

      let inventoryInfo = [];
      let result = editFormData.serviceChild.map((item) => {
        if (item.serviceInventory) {
          inventoryInfo.push({
            inventoryId: item.serviceInventory.id,
            price: item.price,
            alternateGroupId: item.alternateGroupId || "",
          });
        }
      });
      if (inventoryInfo.length > 0) {
        setInventoryList(inventoryInfo);
      }

      setServiceList(serviceData.getAdminService.services);
      setDataCategoryList(otherData.getCategory.categoryList);
      setDataList(data.getInventoryCategory.categories);
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, [data]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    // setLicenseImage(file);
    e.preventDefault();
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();

      formData.append("file", file);

      const { data } = await axios.post(url, formData);
      if (data.success === true) {
        setImage(data.url);
        setImageURL(data.url);
        // setLicenseImage(data.url);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
      // history.push("/dashboard/compliance");
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleAddProductUsed = () => {
    setProductsUsed([...productsUsed, { name: "", imageUrl: "" }]);
  };

  const handleRemoveProductUsed = (index) => {
    const updatedList = [...productsUsed];
    updatedList.splice(index, 1);
    setProductsUsed(updatedList);
  };

  const handleProductUsedNameChange = (index, event) => {
    const updatedList = [...productsUsed];
    updatedList[index] = { ...updatedList[index], name: event.target.value };
    setProductsUsed(updatedList);
  };

  const handleProductUsedImageUpload = async (index, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post(url, formData);
      if (data.success === true) {
        const updatedList = [...productsUsed];
        updatedList[index] = { ...updatedList[index], imageUrl: data.url };
        setProductsUsed(updatedList);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
    }
  };

  const handleRemoveRow1 = (index) => {
    const updatedList = [...recommendServiceList];
    updatedList.splice(index, 1);
    setrecommendServiceList(updatedList);
  };

  const handleAddRow1 = () => {
    setrecommendServiceList([...recommendServiceList, ""]);
  };
  const handleRecommendChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...recommendServiceList];
    updatedList[index] = value;
    setrecommendServiceList(updatedList);
  };

  const handleRemovePackageChild = (index) => {
    const updatedList = [...packageChildServiceIds];
    updatedList.splice(index, 1);
    setPackageChildServiceIds(updatedList);
  };

  const handleAddPackageChild = () => {
    setPackageChildServiceIds([...packageChildServiceIds, ""]);
  };

  const handlePackageChildChange = (index, event) => {
    const { value } = event.target;
    const updatedList = [...packageChildServiceIds];
    updatedList[index] = value;
    setPackageChildServiceIds(updatedList);
  };

  const handleInventoryChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = value;
    setInventoryList(updatedList);
  };

  const handleInventoryPriceChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = parseInt(value);
    setInventoryList(updatedList);
  };

  const handleRemoveRow = (index) => {
    const updatedList = [...inventoryList];
    updatedList.splice(index, 1);
    setInventoryList(updatedList);
  };

  const handleAddRow = () => {
    setInventoryList([
      ...inventoryList,
      { inventoryId: "", price: "", alternateGroupId: "" },
    ]);
  };

  const onCategoryChange = (e) => {
    setCategory(e.target.value);
    console.log(e.target.value);
    refetch({ data: e.target.value })
      .then((res) => {
        console.log("onCategoryChange hitted");
        console.log(res);
        if (res.data.getProductByCategoryId.status === "SUCCESS") {
          //   window.location.reload();
          setProductList(res.data.getProductByCategoryId.products);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSubmit = (e) => {
    // setOpenServiceForm(false);
    // console.log(name, price, category, subCategory, inventoryList, description);
    e.preventDefault();
    let finalDataObj = {};

    const cleanedList = recommendServiceList.filter(
      (service) => service !== "" && service !== "none"
    );

    if (freeService === "" || freeService === "none") {
      freeService = null;
    }

    // Update the state with the cleaned list

    finalDataObj.id = editFormData.id;
    finalDataObj.name = name;
    finalDataObj.imageURL = imageURL;
    finalDataObj.price = parseInt(price);
    finalDataObj.productId = subCategory;
    finalDataObj.description = description;
    finalDataObj.inventoryList = inventoryList;
    finalDataObj.categoryId = category;
    finalDataObj.productId = subCategory;
    finalDataObj.time = parseInt(time);
    finalDataObj.gender = gender;
    finalDataObj.isFeatured = isFeatured;
    finalDataObj.cutPrice = parseInt(cutPrice);
    finalDataObj.quickPrice = parseInt(quick_price);
    finalDataObj.freeService = freeService;
    finalDataObj.recommendations = cleanedList;
    finalDataObj.shortDescription = shortDescription;
    finalDataObj.specialPrice = parseInt(specialPrice);
    finalDataObj.campaignPrice = campaignPrice ? parseInt(campaignPrice) : null;
    finalDataObj.campaignStartAt = campaignStartAt || null;
    finalDataObj.campaignEndAt = campaignEndAt || null;
    finalDataObj.campaignLabel = campaignLabel;

    finalDataObj.details = details;
    finalDataObj.metaData = metaData;
    finalDataObj.displayOrder = parseInt(displayOrder);
    
    finalDataObj.isPackage = isPackage;
    finalDataObj.allowTimeBypass = allowTimeBypass;
    finalDataObj.requiresTimerVerification = requiresTimerVerification;
    finalDataObj.selectionCount = parseInt(selectionCount) || 0;
    finalDataObj.inventoryGenerationMode = inventoryGenerationMode;
    finalDataObj.packageChildServiceIds = packageChildServiceIds.filter(
      (id) => id !== "" && id !== "none"
    );
    finalDataObj.productsUsed = productsUsed
      .filter((p) => p.name.trim() !== "" || p.imageUrl)
      .map((p) => ({ name: p.name, imageUrl: p.imageUrl }));

    console.log(finalDataObj);
    updateService({
      variables: {
        data: finalDataObj,
      },
    })
      .then((res) => {
        console.log("update service res is");
        console.log(res);
        if (res.data.updateService.status === "SUCCESS") {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const subCategoryClass = subCategory ? "text-white" : " text-[#9A9A9A]";
  const categoryClass = category ? "text-white" : " text-[#9A9A9A]";

  const emptyList = [""];
  if (!isFetched) return <Loader />;
  return (
    <div>
      {isFetched && (
        <div className="flex flex-col py-3 px-2 space-y-5">
          <BackButton onClick={() => setEditForm(false)} />
          <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
            Edit Service
          </h3>
          <div className="w-full flex flex-col space-y-8">
            <input
              type="text"
              placeholder="Name*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Price*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <input
              type="text"
              placeholder="Time*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
            <input
              type="text"
              placeholder="details*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={details}
              onChange={(e) => setdetails(e.target.value)}
            />
            <select
              placeholder="Category*"
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${categoryClass}`}
              value={category}
              // onChange={(e) => setCategory(e.target.value)}
              onChange={onCategoryChange}
            >
              <option value="" disabled hidden>
                Category*
              </option>
              {/* <option value="men">Men</option>
          <option value="women">Women</option> */}
              {dataCategoryList.map((item, i) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
            <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${subCategoryClass}`}
              value={subCategory}
              onChange={(e) => setSubCategory(e.target.value)}
            >
              <option value="" disabled selected hidden>
                Sub-Category*
              </option>
              {/* <option value="hair">hair</option>
          <option value="beard">beard</option>
          <option value="spa">spa</option>
          <option value="nail">nail</option> */}
              {productList.length > 0 &&
                productList.map((item, i) => (
                  <option value={item.id}>{item.name}</option>
                ))}
            </select>
            <select
              placeholder="Category*"
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${categoryClass}`}
              value={gender}
              // onChange={(e) => setCategory(e.target.value)}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="" disabled hidden>
                Gender*
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>

            <LabeledSwitch
              checked={isFeatured}
              onChange={(e) => setIsFeatured(e)}
              label={"Is Featured"}
              leftLabel="No"
              rightLabel="Yes"
            />
            <div className="flex items-center">
              <input
                id="image-upload"
                type="file"
                ref={fileInputRef}
                className="hidden"
                onChange={handleImageUpload}
              />
              <input
                type="text"
                placeholder="Upload Image*"
                disabled={true}
                className="w-4/5 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              />
              <IoMdCloudUpload
                className="text-[#9A9A9A] text-3xl"
                onClick={handleBrowseClick}
              />
              {/* <p className="ml-3 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer">
            Mark as Primary
          </p> */}
              {editFormData.imageURL && (
                <a
                  className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer"
                  target="_blank" rel="noreferrer"
                  href={`https://api.barbera.in${editFormData.imageURL}`}
                >
                  View
                </a>
              )}
            </div>

            <div className="flex flex-col space-y-4 p-4 border border-[#FBB033] rounded-md">
              <h4 className="text-[#FBB033] font-be-jost-pro font-bold text-lg">
                Products Used
              </h4>
              <p className="text-[#9A9A9A] text-sm">
                Add the products used for this service - shown to the customer so they know what to expect.
              </p>
              {productsUsed.map((product, index) => (
                <div className="flex items-center space-x-2 lg:space-x-8" key={index}>
                  <input
                    type="text"
                    placeholder="Product name (e.g. XYZ Shampoo)"
                    className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-1/2 lg:w-[35%]"
                    value={product.name}
                    onChange={(e) => handleProductUsedNameChange(index, e)}
                  />
                  <input
                    id={`product-used-image-${index}`}
                    type="file"
                    className="hidden"
                    onChange={(e) => handleProductUsedImageUpload(index, e)}
                  />
                  <label htmlFor={`product-used-image-${index}`} className="cursor-pointer">
                    <IoMdCloudUpload className="text-[#9A9A9A] text-3xl" />
                  </label>
                  {product.imageUrl && (
                    <img
                      src={`https://api.barbera.in${product.imageUrl}`}
                      alt={product.name}
                      className="w-10 h-10 object-cover rounded"
                    />
                  )}
                  <AiOutlineDelete
                    className="text-[#FBB033] text-2xl cursor-pointer"
                    onClick={() => handleRemoveProductUsed(index)}
                  />
                </div>
              ))}
              <span
                className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                onClick={handleAddProductUsed}
              >
                {`Add Product +`}
              </span>
            </div>
            {/* <div className="w-full"> */}
            {inventoryList.map((inventory, index) => {
              return (
                <div className="flex space-x-2 lg:space-x-8" key={index}>
                  <select
                    className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${inventory.inventoryId === ""
                        ? " text-[#9A9A9A]"
                        : "text-white"
                      } w-1/2 lg:w-[25%]`}
                    value={inventory.inventoryId}
                    onChange={(e) => handleInventoryChange(index, e)}
                    name="inventoryId"
                  >
                    <option value="" disabled hidden>
                      Inventory*
                    </option>
                    {/* <option value="Hair Cutting Kit">Hair Cutting Kit</option>
                <option value="Hair Color Kit">Hair Color Kit</option> */}
                    {dataList.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <div className="flex items-center">
                    <span
                      className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                      onClick={handleAddRow}
                    >
                      {`Add Inventory +  `}
                    </span>
                    {inventoryList.length !== 1 && (
                      <AiOutlineDelete
                        className="text-[#FBB033] text-2xl cursor-pointer"
                        onClick={() => handleRemoveRow(index)}
                      />
                    )}
                  </div>
                  <input
                    type="number"
                    placeholder="Amount*"
                    className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-1/3"
                    value={parseInt(inventory.price)}
                    onChange={(event) =>
                      handleInventoryPriceChange(index, event)
                    }
                    name="price"
                  />
                  <input
                    type="text"
                    placeholder="Alternate group (optional)"
                    title="Rows with the same tag become interchangeable alternates - the employee picks one at start of service."
                    className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-1/3"
                    value={inventory.alternateGroupId || ""}
                    onChange={(event) =>
                      handleInventoryChange(index, event)
                    }
                    name="alternateGroupId"
                  />
                </div>
              );
            })}

            {recommendServiceList.length === 0
              ? setrecommendServiceList(emptyList)
              : recommendServiceList}

            {recommendServiceList.map((service, index) => {
              console.log("Tanish -----------------------");
              console.log(service);

              let serviceName = "";

              // Ensure empty string still renders
              if (service !== "") {
                for (let i = 0; i < serviceList.length; i++) {
                  if (service === serviceList[i].id) {
                    serviceName = serviceList[i].id;
                    console.log("serviceName", serviceName);
                  }
                }
              }

              return (
                <div className="flex space-x-2 lg:space-x-8" key={index}>
                  <select
                    className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${serviceName === "" ? "text-[#9A9A9A]" : "text-white"
                      } w-1/2 lg:w-[25%]`}
                    value={serviceName}
                    onChange={(e) => handleRecommendChange(index, e)}
                    name="service"
                  >
                    <option value="" disabled>
                      Select Service
                    </option>
                    <option value="none">None</option>
                    {serviceList.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                  </select>

                  <div className="flex items-center">
                    <span
                      className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                      onClick={handleAddRow1}
                    >
                      {`Add RecommendService +  `}
                    </span>
                    {recommendServiceList.length >= 2 && (
                      <AiOutlineDelete
                        className="text-[#FBB033] text-2xl cursor-pointer"
                        onClick={() => handleRemoveRow1(index)}
                      />
                    )}
                  </div>
                </div>
              );
            })}
            <input
              type="text"
              placeholder="Description*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={description}
              onChange={(e) => SetDesciption(e.target.value)}
            />
            <input
              type="text"
              placeholder="ShortDescription*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={shortDescription}
              onChange={(e) => setshortDescription(e.target.value)}
            />
            <input
              type="number"
              placeholder="Cutprice*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={cutPrice}
              onChange={(e) => setCutPrice(e.target.value)}
            />
            <input
              type="number"
              placeholder="Quick_price*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={quick_price}
              onChange={(e) => setquick_price(e.target.value)}
            />
            <input
              type="number"
              placeholder="Special_Price*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={specialPrice}
              onChange={(e) => setspecialPrice(e.target.value)}
            />

            <input
              type="number"
              placeholder="Campaign Price"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignPrice}
              onChange={(e) => setCampaignPrice(e.target.value)}
            />
            <input
              type="text"
              placeholder="Campaign Label (e.g. MONSOON OFFER)"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignLabel}
              onChange={(e) => setCampaignLabel(e.target.value)}
            />
            <label className="text-[#9A9A9A] text-sm">Campaign Start</label>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignStartAt}
              onChange={(e) => setCampaignStartAt(e.target.value)}
            />
            <label className="text-[#9A9A9A] text-sm">Campaign End</label>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignEndAt}
              onChange={(e) => setCampaignEndAt(e.target.value)}
            />
            <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${categoryClass}`}
              value={freeService}
              onChange={(e) => setFreeService(e.target.value)}
            >
              <option value="" disabled hidden>
                Select Service*
              </option>
              <option value="none">None</option>
              {serviceList.map((item, i) => (
                <option key={i} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Display Order*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={displayOrder}
              onChange={(e) => setDisplayOrder(e.target.value)}
            />

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="isPackage"
                checked={isPackage}
                onChange={(e) => setIsPackage(e.target.checked)}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="isPackage" className="text-white text-lg font-be-jost-pro cursor-pointer">
                Is this a Package?
              </label>
            </div>

            <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="allowTimeBypass"
                checked={allowTimeBypass}
                onChange={(e) => setAllowTimeBypass(e.target.checked)}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="allowTimeBypass" className="text-white text-lg font-be-jost-pro cursor-pointer">
                Allow Time Bypass (Add-on Conflicts)
              </label>
            </div>

            <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="requiresTimerVerification"
                checked={requiresTimerVerification}
                onChange={(e) => setRequiresTimerVerification(e.target.checked)}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="requiresTimerVerification" className="text-white text-lg font-be-jost-pro cursor-pointer">
                Requires Timer Verification (customer confirms start, live countdown shown on both apps)
              </label>
            </div>


            {isPackage && (
              <div className="flex flex-col space-y-6 p-4 border border-[#FBB033] rounded-md">
                <h4 className="text-[#FBB033] font-be-jost-pro font-bold text-lg">Package Configuration</h4>
                
                <input
                  type="number"
                  placeholder="Selection Count (e.g., Pick Any 3)*"
                  className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
                  value={selectionCount}
                  onChange={(e) => setSelectionCount(e.target.value)}
                />

                <select
                  className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white`}
                  value={inventoryGenerationMode}
                  onChange={(e) => setInventoryGenerationMode(e.target.value)}
                >
                  <option value="ON_BOOKING">ON BOOKING (Fixed Bundle)</option>
                  <option value="ON_SELECTION">ON SELECTION (Dynamic Pick-Any)</option>
                </select>

                <div className="flex flex-col space-y-4">
                  <p className="text-white text-sm">Select Child Services for this Package:</p>
                  {packageChildServiceIds.map((service, index) => {
                    return (
                      <div className="flex space-x-2 lg:space-x-8" key={index}>
                        <select
                          className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${service === "" ? "text-[#9A9A9A]" : "text-white"} w-1/2 lg:w-[25%]`}
                          value={service}
                          onChange={(e) => handlePackageChildChange(index, e)}
                        >
                          <option value="" disabled>Select Child Service</option>
                          <option value="none">None</option>
                          {serviceList && serviceList.map((item, i) => (
                            <option value={item.id} key={i}>
                              {item.name}
                            </option>
                          ))}
                        </select>

                        <div className="flex items-center">
                          <span
                            className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                            onClick={handleAddPackageChild}
                          >
                            Add Child Service +
                          </span>
                          {packageChildServiceIds.length >= 2 && (
                            <AiOutlineDelete
                              className="text-[#FBB033] text-2xl cursor-pointer ml-4"
                              onClick={() => handleRemovePackageChild(index)}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <textarea
              placeholder='{"services": ["facial", "cleanup"]}'
              className="px-2 py-1 bg-[#0c0b0b] border-b border-b-[#E0E0E0] outline-none text-white w-full h-32"
              value={metaDataInput}
              onChange={(e) => {
                const input = e.target.value;
                setMetaDataInput(input); // ALWAYS update UI

                try {
                  const parsed = JSON.parse(input);
                  setMetaData(parsed); // update only if valid
                } catch {
                  // do nothing → allow typing
                }
              }}
            />
            <div className="flex items-center justify-center">
              <button
                className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
                onClick={handleSubmit}
              >
                Add Service
              </button>
            </div>
            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceEditForm;
